import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { fadeInOnEnterAnimation } from 'angular-animations';
import { TelerikReportViewerComponent } from '@progress/telerik-angular-report-viewer';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { SettingService } from 'src/app/admin/_services/setting.service';
import $ from 'jquery';

@Component({
   selector: 'app-report',
   templateUrl: './report.component.html',
   styleUrls: ['./report.component.scss'],
   animations: [fadeInOnEnterAnimation()],
})
export class ReportComponent implements OnInit, AfterViewInit {
   @ViewChild('viewer1') viewer: TelerikReportViewerComponent;
   dateUpdated = false; // Flag to indicate that date format has been set
   reportName: string;
   companyName: string;
   isSalesLease = false;
   registrationNumber: string;
   logo: string;

   viewerContainerStyle = {
      position: 'fixed',
      top: '74px',
      bottom: '0',
      right: '0',
      left: '240px',
      ['font-family']: 'ms sans serif',
   };

   Url = environment.apiUrl + 'reports';
   constructor(private route: ActivatedRoute, private settingService: SettingService) {}
   ngAfterViewInit(): void {
      this.settingService.getSettings().subscribe((settingList) => {
         settingList.forEach((setting) => {
            if (setting.id === 'LOGO') {
               if (setting.settingValue === '') {
                  this.logo = 'Company.png';
               } else {
                  this.logo = '../../' + setting.settingValue;
               }
            }
            if (setting.id === 'COMPNAME') {
               this.companyName = setting.settingValue;
            }
            if (setting.id === 'COMPREGNO') {
               this.registrationNumber = setting.settingValue;
            }
         });
         this.route.paramMap.subscribe((params) => {
            this.reportName = params.get('type') + '.trdp';
         });
         if(this.reportName === 'SalesLeaseValidationReport.trdp') {
            this.reportName = 'LeaseValidationReport.trdp';
             const rs = {
            report: this.reportName ,
            parameters: { Logo: this.logo, CompanyName: this.companyName + ' - ' + this.registrationNumber, IsSalesLease: true },
         };
      
         this.viewer.setReportSource(rs);
         }
         else
         {
         const rs = {
            report: this.reportName,
            parameters: { Logo: this.logo, CompanyName: this.companyName + ' - ' + this.registrationNumber },
         };
      
         this.viewer.setReportSource(rs);
      }
      });
   }
   ngOnInit() {}

   setDateFormat(dateFormat) {
      var datepicker = $('#reportViewer1').find("[data-role='datepicker']");
      if (datepicker.length > 0) {
         this.dateUpdated = true;

         for (var i = 0; i < datepicker.length; i += 1) {
            var dp = $(datepicker[i]).data('kendoDatePicker');
            var oldValue = dp.value();

            dp.setOptions({
               format: dateFormat,
            });
            dp.value(oldValue);
         }
      }
   }

   onUpdateUi() {
      // Skip if date format already set
      if (!this.dateUpdated) {
         this.setDateFormat('dd/MM/yyyy'); //SPECIFY THE DATE FORMAT HERE
      }
   }
}
